import React from "react";
import axios from "axios";
import pathToRegexp from "path-to-regexp";
import { withRouter } from "react-router-dom";
import {Loading} from "./partials/Global/Loading";
import Pagination from "./partials/Global/Pagination";
import {CopyRight} from "./partials/Global/CopyRight";
import AuctionInfo from "./AuctionDetail/AuctionInfo";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import AuctionEstate from "./AuctionDetail/AuctionEstate";
import {DottedLoading} from "./partials/Global/DottedLoading";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";
import {SearchBox} from "./partials/Global/SearchBox";

class AuctionDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auctionInfo: {},
            auctionInfoIsLoading: true,

            files: [],
            paginate: [],
            isLoading: true,
            searchParams: {
                city: null,
                province: null,
                usageType: null,
                fileType: null,
                fileCode: '',
                minApproximatePrice: '',
                maxApproximatePrice: '',
                minLandMeter: '',
                maxLandMeter: '',
                minTotalMeter: '',
                maxTotalMeter: ''
            }
        };

        const query = new URLSearchParams(this.props.location.search);

        // Get search params from url and update state
        const searchParamsFromUrl = { ...this.state.searchParams };
        for (let pair of query.entries()) {
            if (this.state.searchParams.hasOwnProperty(pair[0])) {
                searchParamsFromUrl[pair[0]] = pair[1];
            }
        }

        this.state.searchParams = searchParamsFromUrl;

        // Set current page from url or 1
        this.state.paginate.currentPage = query.get("page") || 1;
    }

    componentDidMount() {
        (async () => {
            // Get auction info
            await this.getAuctionInfo(this.props.match.params.id);

            // do search
            this.search();
        })();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const query = new URLSearchParams(this.props.history.location.search);

        // Change Url if any of search params state changes.
        if (this.state.searchParams !== prevState.searchParams) {
            const pathSegments = {...this.props.match.params};
            const toPath = pathToRegexp.compile(this.props.match.path);

            Object.keys(this.state.searchParams).forEach(param => {
                if (this.state.searchParams[param] !== prevState.searchParams[param]) {
                    query.has(param)
                        ? query.set(param, this.state.searchParams[param])
                        : query.append(param, this.state.searchParams[param]);
                }

                if (this.state.searchParams[param] !== prevState.searchParams[param] && param === "transactionType") {
                    // Change transactionType segment of url
                    pathSegments.transactionType = this.state.searchParams[param];
                }

                query.set("page", "1");
            });

            const newPath = toPath({...pathSegments});

            let numberInputChanged = [
                "minApproximatePrice",
                "maxApproximatePrice",
                "minLandMeter",
                "maxLandMeter",
                "minTotalMeter",
                "maxTotalMeter"
            ].some(val => this.state.searchParams[val] != prevState.searchParams[val]);

            // If numeric input values changed just replace url otherwise push
            numberInputChanged
                ? this.props.history.replace(decodeURIComponent(newPath) + "?" + decodeURIComponent(query.toString()))
                : this.props.history.push(decodeURIComponent(newPath) + "?" + decodeURIComponent(query.toString()));
        }

        // Change Url paginate state changes. And run search again
        if (this.state.paginate.currentPage !== prevState.paginate.currentPage) {
            query.set("page", this.state.paginate.currentPage);
            this.props.history.push(
                decodeURIComponent(this.props.location.pathname) + "?" + decodeURIComponent(query.toString())
            );
            this.search();
        }
    }

    getAuctionInfo = async auctionId => {
        const result = await axios.post(
            process.env.REACT_APP_API_URL +
            process.env.REACT_APP_GET_AUCTION_INFO_PATH +
            auctionId + ".json", {
                apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN,
            });

        const auctionInfo = result.data.result.data.auctionInfo;

        this.setState({
            auctionInfo: auctionInfo,
            auctionInfoIsLoading: false
        });

        return result;
    };

    search = () => {
        this.setState({ isLoading: true, files: [] });
        const {filters, sort} = this.prepareSearchRequest();
        const requestBody = {
            sort: sort,
            filters: filters,
            id: this.props.match.params.id,
            apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN
        };

        axios
            .post(
                process.env.REACT_APP_API_URL +
                    process.env.REACT_APP_GET_AUCTION_ESTATES_PATH +
                    this.state.paginate.currentPage + '/' +
                    "12.json",
                { ...requestBody }
            )
            .then(response => {
                if (response.status === 200 && response.data.result.status === true) {
                    this.setState({
                        files: response.data.result.data.files,
                        paginate: response.data.result.data.paginate,
                        isLoading: false
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    };

    prepareSearchRequest = () => {
        const searchParams = this.state.searchParams;
        const filters = {viewApartmentFiles: {RANGE: {}}};
        const viewApartmentFiles = filters.viewApartmentFiles;
        const range = filters.viewApartmentFiles.RANGE;

        Object.keys(searchParams).forEach(key => {
            switch (key) {
                case "province":
                    if (searchParams[key] && searchParams[key] !== null && searchParams[key] !== 'null') {
                        viewApartmentFiles.province_id = searchParams[key];
                    }
                    break;
                case "city":
                    if (searchParams[key] && searchParams[key] !== null && searchParams[key] !== 'null') {
                        viewApartmentFiles.city_id = searchParams[key];
                    }
                    break;
                case "usageType":
                    if (searchParams[key] && searchParams[key] !== null && searchParams[key] !== 'null') {
                        viewApartmentFiles.usage_type_id = searchParams[key];
                    }
                    break;
                case "fileType":
                    if (searchParams[key] && searchParams[key] !== null && searchParams[key] !== 'null') {
                        viewApartmentFiles.file_type_id = searchParams[key];
                    }
                    break;
                case "fileCode":
                    if (searchParams[key]) {
                        viewApartmentFiles.file_code = searchParams[key];
                    }
                    break;
                case "minApproximatePrice":
                    if (searchParams[key]) {
                        range.bank_part_price = {...range.bank_part_price, min: searchParams[key]};
                    }
                    break;
                case "maxApproximatePrice":
                    if (searchParams[key]) {
                        range.bank_part_price = {...range.bank_part_price, max: searchParams[key]};
                    }
                    break;
                case "minLandMeter":
                    if (searchParams[key]) {
                        range.land_meter = {...range.land_meter, min: searchParams[key]};
                    }
                    break;
                case "maxLandMeter":
                    if (searchParams[key]) {
                        range.land_meter = {...range.land_meter, max: searchParams[key]};
                    }
                    break;
                case "minTotalMeter":
                    if (searchParams[key]) {
                        range.total_meters = {...range.total_meters, min: searchParams[key]};
                    }
                    break;
                case "maxTotalMeter":
                    if (searchParams[key]) {
                        range.total_meters = {...range.total_meters, max: searchParams[key]};
                    }
                    break;
            }
        });

        return {filters};
    };

    updateSearchParams = (searchParams, performSearch = true) => {
        const paginate = { ...this.state.paginate };
        paginate.currentPage = 1;

        this.setState({ searchParams, paginate }, () => {
            performSearch && this.search();
        });
    };

    updatePaginate = currentPage => {
        const paginate = { ...this.state.paginate };
        paginate.currentPage = currentPage;
        this.setState({ paginate });
    };

    render() {
        return (
            <>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main className="main-bg">
                    {!this.state.auctionInfoIsLoading
                        ? <AuctionInfo auctionInfo={this.state.auctionInfo}/>
                        : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}
                    <section className="main-shop section-padding-50">
                        <div className="container">
                            <div className="row md-marg">
                                <div className="col-lg-3">
                                    <SearchBox
                                        searchParams={this.state.searchParams}
                                        updateSearchParams={this.updateSearchParams}/>
                                </div>
                                <div className="col-lg-9">
                                    <div className="shop-products">
                                        <div className="top-side d-flex align-items-end mb-40">
                                            <div>
                                                <h6 className="fz-16 line-height-1">
                                                    فهرست فایل‌های مزایده
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {!this.state.isLoading
                                                ? Object.keys(this.state.files)
                                                    .map((key) => (
                                                        <AuctionEstate
                                                            key={key}
                                                            auction_is_active={this.state.auctionInfo.is_active}
                                                            file={this.state.files[key]}/>
                                                    ))
                                                : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}
                                        </div>
                                        {!this.state.isLoading && this.state.files.length >= 1 &&
                                        <div className="pagination d-flex justify-content-center mt-30">
                                            <Pagination
                                                paginate={this.state.paginate}
                                                updatePaginate={this.updatePaginate}
                                            />
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </>
        );
    }
}

export default withRouter(AuctionDetail);
